import functions from '../functions';
import Slider from "../components/Slider";

let id = 0;
const instance = {};

class DeparturePickerSlider {
    constructor($elem) {
        this.id = ++id;
        instance[this.id] = this;
        this.params = {};
        this.$elem = $elem.empty();

        this.getParams();

        this.departures = JSON.parse($elem.attr('data-departures'));
        this.printDepartures();
        this.initDepartureCalendar();

        this.$elem.on('click', '.departure', e => {
            const $target = $(e.currentTarget);
            let departure = JSON.parse($target.attr('data-departure'));
            this.getParams();

            functions.setUrlData({
                dateFrom: departure.dateFrom,
                dateTo: departure.dateTo,
                aDateFrom: departure.aDateFrom,
                aDateTo: departure.aDateTo,
                time: departure.time,
                guests: this.params.guests,
                transportUnitId: this.params.transportUnitId,
                placeFromId: this.params.placeFromId,
            }, true);
        });
    }

    getParams() {
        this.params = $.extend({}, this.params, functions.getUrlData(true));
    }

    printDepartures() {
        this.departures.forEach(departure => {

            let departurePrice = departure.price;
            if (departure.numberOfPersons) {
                departurePrice /= departure.numberOfPersons;
            }
            
            this.$elem.append(`
                <div class="keen-slider__slide">
                    <div class="departure"
                        data-departure='${JSON.stringify(departure)}'
                        data-dateFrom="${departure.dateFrom}">
                        ${ ! departure.available ? `<div class="badge bg-danger">RASPRODATO</div>` : ''}
                        <div class="departure-nights">${departure.nights} noćenja</div>
                        <div class="departure-weekDayFrom">${departure.weekDayFrom.substr(0, 3)}</div>
                        <div class="departure-dateFrom">${functions.formatDate(departure.dateFrom, true)}</div>
                        <div class="departure-price-wrapper"><span class="departure-price-label">od</span> <span class="departure-price-price">€${functions.formatMoney(departurePrice, 0, '', '')}<span></div>
                    </div>
                </div>
            `);
        });
    }

    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 7;
            
            let slidesPerView = 7;

            // if(length < perView) {
            //     $('.booking-calendar-wrapper').addClass('col-lg-' + (slidesPerView + 3));
            //     $('.booking-calendar-wrapper').addClass('mx-auto');
            // }
    
            this.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                arrows: functions.isMobile() || length > slidesPerView,
                slides: {
                    perView: slidesPerView,
                    spacing: 0,
                },
                breakpoints: {
                    '(min-width: 993px) and (max-width: 1360px)': {
                        controls: true,
                        arrows: length > 5,
                        //centered: true,
                        slides: {
                            perView: 5,
                        },
                    },
                    '(min-width: 577px) and (max-width: 992px)': {
                        controls: true,
                        arrows: length > 4,
                        //centered: true,
                        slides: {
                            perView: 4,
                        },
                    },
                    '(max-width: 576px)': {
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                        slides: {
                            perView: 2,
                        },
                    },
                },
                detailsChanged: (s) => {
                    $('.booking-calendar-wrapper').find('[data-dir="prev"]').toggleClass('invisible', s.track.details.rel == 0);
                }
            });
        }
    }

}

export {
	DeparturePickerSlider
};